import { Flex } from "@redotech/arbiter/flex";
import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";

export const FirstMileCarrierInput = groupInput({
  accountNumber: input<string>({ validator: nonEmptyValidator }),
  username: input<string>({ validator: nonEmptyValidator }),
  password: input<string>({ validator: nonEmptyValidator }),
});

export type FirstMileCarrierValue = InputSchema.Value<
  typeof FirstMileCarrierInput
>;

export type FirstMileCarrierForm = InputSchema.Input<
  typeof FirstMileCarrierInput
>;

export const firstmileCarrierDefault = (): FirstMileCarrierValue => ({
  accountNumber: "",
  username: "",
  password: "",
});

export const CreateFirstMileCarrierForm = memo(
  function CreateFirstMileCarrierForm({
    carrierInput,
  }: {
    carrierInput: FirstMileCarrierForm;
  }) {
    return (
      <Flex dir="column">
        <RedoTextInput
          label="Account number"
          placeholder=""
          setValue={carrierInput.inputs.accountNumber.setValue}
          value={carrierInput.inputs.accountNumber.value}
        />
        <RedoTextInput
          label="Username"
          placeholder=""
          setValue={carrierInput.inputs.username.setValue}
          value={carrierInput.inputs.username.value}
        />
        <RedoTextInput
          label="Password"
          placeholder=""
          setValue={carrierInput.inputs.password.setValue}
          value={carrierInput.inputs.password.value}
        />
      </Flex>
    );
  },
);
